var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":"header"}}),_c('router-view',{attrs:{"staticaddr":_vm.staticaddr,"serveraddr":_vm.serveraddr}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }